"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorInitialsAvatar = void 0;
exports.colorInitialsAvatar = [
    '#3ec55d',
    '#f15588',
    '#ffb229',
    '#8f63ff',
    '#00b1cd',
    '#1abc9c',
    '#2ecc71',
    '#3498db',
    '#27ae60',
    '#2980b9',
    '#8e44ad',
    '#f1c40f',
    '#e67e22',
    '#e74c3c',
    '#f39c12',
    '#c0392b',
    '#bdc3c7',
];
//# sourceMappingURL=InitialsAvatar.interface.js.map